/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getEquipementsFromSiteByQrCode } from '../fn/site-equipements-controller/get-equipements-from-site-by-qr-code';
import { GetEquipementsFromSiteByQrCode$Params } from '../fn/site-equipements-controller/get-equipements-from-site-by-qr-code';

/**
 * site equipements.
 */
@Injectable({ providedIn: 'root' })
export class SiteEquipementsControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEquipementsFromSiteByQrCode()` */
  static readonly GetEquipementsFromSiteByQrCodePath = '/v1/sites/{idSite}/equipements/byQrCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementsFromSiteByQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsFromSiteByQrCode$Response(
    params: GetEquipementsFromSiteByQrCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return getEquipementsFromSiteByQrCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementsFromSiteByQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsFromSiteByQrCode(params: GetEquipementsFromSiteByQrCode$Params, context?: HttpContext): Observable<{}> {
    return this.getEquipementsFromSiteByQrCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<{}>): {} => r.body)
    );
  }
}
